import "core-js/modules/es.array.push.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
moment.locale("ja");
const __default__ = {
  name: "AttendanceIndex",

  data() {
    return {
      fiscalYear: moment().add(-3, "month").year(),
      filterStatus: {
        type: "",
        classroom: ""
      },
      date: moment().format("YYYY-MM-DD"),
      formattedDate: moment().format("YYYY年MM月DD日(ddd)"),
      showModal: false,
      attendances: [],
      filteredAttendances: [],
      detail: {},
      byClassrooms: [],
      isLoading: true
    };
  },

  computed: { ...mapState(["studentAddress", "school"]),
    currentYM: function () {
      return moment(this.date).format("YYYY-MM");
    }
  },

  async created() {
    if (moment(this.$route.query.date, "YYYY-MM-DD", true).isValid()) {
      this.date = this.$route.query.date;
    }

    if (this.$route.query.keyword) {
      this.filterStatus.keyword = this.$route.query.keyword;
    }

    if (this.$route.query.type) {
      this.filterStatus.type = this.$route.query.type;
    }

    if (this.$route.query.classroom_id && this.classrooms.find(v => Number(v.id) === Number(this.$route.query.classroom_id))) {
      this.filterStatus.classroom = this.$route.query.classroom_id;
    }

    await this.getAttendance();
    this.isLoading = false;
  },

  methods: {
    iconColor,

    async getAttendance() {
      this.formattedDate = moment(this.date).format("YYYY年MM月DD日(ddd)");

      if (this.schoolPlan.temperature) {
        const data = await getData(["attendances?date=" + this.date + "&orderby=created_at&with=student.classroom&show_daily_all=1", `temperatures?date=${this.date}`]).catch(error => {
          console.log(error);
          return null;
        });

        if (!data) {
          this.isLoading = false;
          return;
        }

        this.temperatureCount = data[1].items.count;
        this.attendances = data[0].items;
      } else {
        const data = await getData(["attendances?date=" + this.date + "&orderby=created_at&with=student.classroom&show_daily_all=1"]).catch(error => {
          console.log(error);
          return null;
        });

        if (!data) {
          this.isLoading = false;
          return;
        }

        this.attendances = data[0].items;
      }

      let attendances = this.attendances;
      const keyword = this.filterStatus.keyword;
      const classroom = Number(this.filterStatus.classroom);
      const type = this.filterStatus.type;

      if (keyword) {
        attendances = attendances.filter(v => Object.keys(v).some(k => String(v[k]).indexOf(keyword) > -1));
      }

      if (type) {
        if (type === "登下校") {
          const attendances1 = attendances.filter(v => Object.keys(v).some(k => String(v[k]).indexOf("登校") > -1));
          const attendances2 = attendances.filter(v => Object.keys(v).some(k => String(v[k]).indexOf("下校") > -1));
          attendances = attendances1.concat(attendances2);
        } else {
          attendances = attendances.filter(v => v.type.indexOf(type) > -1);
        }
      }

      if (classroom) {
        attendances = attendances.filter(v => v.student && v.student.class_id === classroom); //クラス検索のときはそのクラスだけ表示だけする

        this.byClassrooms = [{
          attendances: [],
          classroom: this.classrooms.find(v => v.id === classroom)
        }];
      } else {
        this.byClassrooms = [];
        this.classrooms.forEach(v => {
          this.byClassrooms.push({
            attendances: [],
            classroom: v
          });
        });
      }

      attendances.sort((a, b) => {
        if (a.student_id !== b.student_id) {
          if (a.student.ruby > b.student.ruby) {
            return 1;
          }

          if (a.student.ruby < b.student.ruby) {
            return -1;
          }
        }

        const aDate = moment(a.created_at);
        const bDate = moment(b.created_at);

        if (aDate.isBefore(bDate)) {
          return 1;
        }

        if (bDate.isBefore(aDate)) {
          return -1;
        }

        return 0;
      });
      this.attendances = this.filteredAttendances = attendances.map(v => {
        return {
          id: v.id,
          student_id: v.student_id,
          student: v.student,
          date: moment(v.date).format("YYYY年MM月DD日(ddd)"),
          name: v.name,
          comment: v.comment,
          guardian_memo: v.guardian_memo,
          type: v.type,
          typeText: Text.attendances.type[v.type],
          created_at: v.created_at,
          classrooms_id: v.student && v.student.classroom ? v.student.classroom.id : null,
          classrooms_name: v.student && v.student.classroom ? v.student.classroom.name : null,
          is_daily_latest: v.is_daily_latest
        };
      });
      this.filteredAttendances.forEach(v => {
        this.byClassrooms.forEach(v2 => {
          if (v2.classroom.id === v.classrooms_id) {
            v2.attendances.push(v);
          }
        });
      });
      this.isLoading = false;
    },

    filterAttendances() {
      const query = moment().isSame(this.date, "day") ? {} : {
        date: this.date
      };
      if (this.filterStatus.keyword) query["keyword"] = this.filterStatus.keyword;
      if (this.filterStatus.classroom) query["classroom_id"] = this.filterStatus.classroom;
      if (this.filterStatus.type) query["type"] = this.filterStatus.type;
      this.$router.push({
        query
      });
      this.getAttendance();
    },

    calcAttendance(list, type) {
      switch (type) {
        case "absent":
          return list.filter(v => v.is_daily_latest && v.type.indexOf("欠席") > -1).length;

        case "late":
          return list.filter(v => v.is_daily_latest && v.type.indexOf("遅刻") > -1).length;

        case "leave":
          return list.filter(v => v.is_daily_latest && v.type.indexOf("早退") > -1).length;

        case "not_attend":
          return list.filter(v => v.is_daily_latest && v.type.indexOf("未登校") > -1).length;

        case "way":
          return list.filter(v => v.type.split("-")[0] === "登校" || v.type.split("-")[0] === "下校").length;
      }
    },

    downloadCSV() {
      const csvArray = [["No", "クラス", this.studentAddress + "氏名", "連絡区分", "欠席理由", "保護者メモ", "先生メモ"]];
      this.attendances.filter(v => v.is_daily_latest).forEach((v, i) => {
        const row = [i + 1, v.classrooms_name, v.student.name, v.type.split("-").shift(), v.type, v.guardian_memo, v.comment];
        csvArray.push(row);
      });
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      saveAs(new Blob([bom, Papa.unparse(csvArray)], {
        type: "text/csv;charset=utf-8"
      }), this.formattedDate + "_出欠席状況.csv");
    }

  }
};
import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { useAbsentAlertStore } from "@/stores/absentAlert";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
import AbsentAlertList from "@/components/attendances/AbsentAlertList.vue";
import moment from "moment";
import Text from "@/consts/text";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { iconColor } from "@/consts/iconColor";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const absentAlertStore = useAbsentAlertStore();
    const {
      absentcontinuouslyObj,
      absentFrequentlyObj
    } = storeToRefs(absentAlertStore);
    const {
      classrooms,
      totalStudentCount
    } = storeToRefs(useGradeClassroomStore());
    const {
      schoolPlan
    } = storeToRefs(useSchoolPlanStore());
    const temperatureCount = ref({});
    const totalTemperatureCount = computed(() => Object.values(temperatureCount.value).reduce((sum, current) => {
      return sum + current;
    }, 0)); // created

    absentAlertStore.getAbsentAlert();
    expose({
      classrooms,
      temperatureCount,
      schoolPlan
    });
    return {
      __sfc: true,
      absentAlertStore,
      absentcontinuouslyObj,
      absentFrequentlyObj,
      classrooms,
      totalStudentCount,
      schoolPlan,
      temperatureCount,
      totalTemperatureCount,
      AbsentAlertList,
      RowItem,
      iconColor
    };
  }

});